import { render } from "./TripsPage.vue?vue&type=template&id=6788cca4"
import script from "./TripsPage.vue?vue&type=script&lang=js"
export * from "./TripsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__